import { GamManagerRunning, GamManagerState } from '@pubstack/common/src/gam/gamManager'
import { MutationToasts, useMutation, useQuery } from '../api-client'

export const GAM_MANAGER_QUERY_KEYS = ['admin', 'gam-manager']

//-------------------------------------------------------------------------
// Queries
//-------------------------------------------------------------------------
export const useGamManagerAdmConfigStatus = (scopeId: string, networkId?: string) => {
  return useQuery<GamManagerRunning>({
    url: `/admin/scopes/${scopeId}/gam-manager/object-creation/${networkId}`,
    keys: [...GAM_MANAGER_QUERY_KEYS, scopeId, 'object-creation', networkId ?? ''],
    enabled: !!networkId,
  })
}

export const useGamManagerState = (scopeId: string, networkId?: string) => {
  return useQuery<GamManagerState | undefined>({
    url: `/admin/scopes/${scopeId}/gam-manager/state/${networkId}`,
    keys: [...GAM_MANAGER_QUERY_KEYS, scopeId, 'state', networkId ?? ''],
    enabled: !!networkId,
  })
}

//-------------------------------------------------------------------------
// Mutations
//-------------------------------------------------------------------------
export const useRunGamManagerCreation = (scopeId: string, networkId: string, toasts: MutationToasts = {}) => {
  return useMutation<void>({
    method: 'put',
    url: `/admin/scopes/${scopeId}/gam-manager/object-creation/${networkId}`,
    collectionKeys: [...GAM_MANAGER_QUERY_KEYS, scopeId],
    ...toasts,
  })
}
